module.exports = [{"key":"1 year","value":"1"},{"key":"3 years","value":"3"},{"key":"5 years","value":"5"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/durations.json
// module id = 2209
// module chunks = 1